import { NgModule } from '@angular/core';
import { AngularResizeElementDirective } from './resize-element.directive';

@NgModule({
  declarations: [AngularResizeElementDirective],
  exports: [AngularResizeElementDirective],
})
export class AngularResizeElementModule {}
